/**
 * @generated SignedSource<<be76941f7a1cf013b3fec764dd504552>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftFeaturedCreatorTile_nftProfile$data = {
  readonly featuredItems: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"NftItemTileMedia_item">;
  } | null> | null;
  readonly publicProfile: {
    readonly profileName: string | null;
    readonly walletAddress: {
      readonly address: string | null;
      readonly publicProfileUrl: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"NftAvatarCircle_address">;
    } | null;
  } | null;
  readonly totalCreations: number | null;
  readonly username: string | null;
  readonly " $fragmentType": "NftFeaturedCreatorTile_nftProfile";
};
export type NftFeaturedCreatorTile_nftProfile$key = {
  readonly " $data"?: NftFeaturedCreatorTile_nftProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftFeaturedCreatorTile_nftProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftFeaturedCreatorTile_nftProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftItem",
      "kind": "LinkedField",
      "name": "featuredItems",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftItemTileMedia_item"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "walletAddress",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NftAvatarCircle_address"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicProfileUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCreations",
      "storageKey": null
    }
  ],
  "type": "NftFeaturedCreatorsProfileType",
  "abstractKey": null
};

(node as any).hash = "81d128313e060e065d57f2edf71ff00e";

export default node;
